import React from "react"

// Kısıtlı sayfa arkasında gösterilen sahte, blur'lu iskelet.
// Gerçek sayfa mount EDİLMEZ; burada hiçbir API çağrısı yoktur — yalnızca
// "kilitli içerik" hissi veren dekoratif kutular.
const bar = (w, h = 14) => (
  <div
    style={{
      width: w,
      height: h,
      borderRadius: 8,
      background: "linear-gradient(90deg, #e9edf3 0%, #f4f6f9 50%, #e9edf3 100%)",
    }}
  />
)

const SkeletonRow = () => (
  <div className="d-flex align-items-center gap-3 py-3 px-3" style={{ borderBottom: "1px solid #eef1f5" }}>
    <div style={{ width: 40, height: 40, borderRadius: 999, background: "#e9edf3", flexShrink: 0 }} />
    <div className="flex-grow-1 d-flex flex-column gap-2">
      {bar("35%")}
      {bar("55%", 10)}
    </div>
    {bar(90, 28)}
    {bar(70, 28)}
  </div>
)

const BlurredSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      filter: "blur(6px)",
      pointerEvents: "none",
      userSelect: "none",
      padding: "1.5rem",
      opacity: 0.9,
    }}
  >
    {/* Başlık bloğu */}
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div className="d-flex flex-column gap-2">
        {bar(220, 22)}
        {bar(140, 12)}
      </div>
      {bar(120, 40)}
    </div>

    {/* İstatistik kartları */}
    <div className="d-flex gap-3 mb-4 flex-wrap">
      {[0, 1, 2, 3].map((i) => (
        <div
          key={i}
          className="card border-0 shadow-sm rounded-4 flex-grow-1"
          style={{ minWidth: 160, padding: "1.25rem" }}
        >
          <div className="d-flex flex-column gap-2">
            {bar("60%", 12)}
            {bar("45%", 24)}
          </div>
        </div>
      ))}
    </div>

    {/* Tablo kartı */}
    <div className="card border-0 shadow-sm rounded-4" style={{ padding: "0.5rem" }}>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  </div>
)

export default BlurredSkeleton
